import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Button from '../../components/buttons/Button';
import { Link, useNavigate } from 'react-router-dom';
import { getUserRole } from '../../utils/localStoarege';
import { toast } from 'react-toastify';
import { getMedicines, updateMedicine } from '../../services/clinic/medicine';
import { CgAdd } from 'react-icons/cg';
import OpenMedicineQuantityAlert from './UpdateMedicineQuantityAlert';
import { GoHistory } from 'react-icons/go';
import { MdDewPoint, MdManageHistory } from 'react-icons/md';
import AllotOpenMedicineAlert from './AllotMedicineAlert';
import Card from '../../components/cards/Card';
import EditableAmount from '../../components/EditableAmount';


function Medicines() {
    const isMedical = getUserRole() === 'medical';
    const [cardData, setCardData] = useState([
        {
            title: "Total Medicines",
            count: "--",
        },
    ]);
    const navigate = useNavigate();
    const [tableData, setTableData] = useState({});

    const headers = [
        { label: "ID", key: "id" },
        { label: "Name", key: "drug_name" },
        // { label: "Batch No", key: "batch_no" },
        { label: "Stock", key: "stock" },
        { label: "Qty. per pack", key: "qty_per_pack" },
        { label: "Amount", key: "amount" },
        { label: "Bar Code", key: "barcode" },
        // { label: "Date", key: "created_at" },
        // { label: "Exp. Date", key: "expiry_date" },
        { label: "Action", key: "action" },
        { label: "Issue", key: "issue" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [addModalIsOpen, setIsAddOpen] = useState(false);
    const [allotModalIsOpen, setIsAllotOpen] = useState(false);
    const [openingValues, setMedicineToDisplay] = useState({});


    const pageSize = 10;

    const fetchData = async () => {
        setLoading(true);
        try {
            let res = await getMedicines();
            if (res.status === 200) {
                setTableData(res.data);
                setCardData([
                    {
                        title: "Total Medicines",
                        count: res.data.count || res.data.results?.length || 0,
                    },
                ]);
            } else {
                toast.error("Unable to fetch medicines");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Medicines:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchData();
    }, []);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const openAddMedicineModal = (values) => {
        setMedicineToDisplay(values);
        setIsAddOpen(true);
    };

    const openAllotMedicineModal = (values) => {
        setMedicineToDisplay(values);
        setIsAllotOpen(true);
    };

    const handlePatchOperation = async (values) => {
        try {
            let res = await updateMedicine({ "amount": values.amount, }, values.id);
            if (res.status === 200) {
                toast.success("Price Updated Successfully");
            } else {
                toast.error("Unable to update medicines");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error updating Medicine:", error);
        } finally {
            setLoading(false);
        }
    };

    const closeModal = () => {
        setIsAddOpen(false);
    };

    const closeAllotModal = () => {
        setIsAllotOpen(false);
    };

    const onUpdateMedicine = () => {
        fetchData();
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/invoice' },
            { name: 'Medicines' },
        ]} />
        <div className="pt-3 pb-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
            <div className="flex flex-row justify-between items-center mt-2">
                <StyledHeadingText text={"Medicines"} />
                <Link to={isMedical ? '/medical/medicines/add' : '/medicine/add'}>
                    <Button children={"Add Medicine"} className="bg-primary text-white rounded-lg" />
                </Link>
            </div>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading imageSrc={loaderImage} size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={tableData?.results?.map((item, index) => (
                            {
                                id: <p>{item.barcode_id}</p>,
                                drug_name: <p>{item.drug_name}</p>,
                                amount: <EditableAmount item={item} key={item.s_no} handlePatchOperation={handlePatchOperation} />,
                                barcode: <img src={item.barcode_image} alt={item.barcode_image} className='max-h-16' />,
                                // batch_no: <p>{item.batch_no}</p>,
                                // expiry_date: <p>{item.phone}</p>,
                                // created_at: <p>{item.created_at}</p>,
                                stock: <p>{item.stock_qt}</p>,
                                qty_per_pack: <p>{item.type === "tablet" ? item.tablets_per_packet : item.ml_per_unit}</p>,
                                action:
                                    <div className='flex flex-row gap-2'>
                                        <span className='cursor-pointer self-center items-center justify-center' onClick={() => openAddMedicineModal(item)} ><CgAdd size={20} /></span>
                                        <span className='cursor-pointer self-center items-center justify-center' onClick={() => navigate(isMedical ? `/medical/medicines/history` : `/medicine/history`, { state: { item } })} ><GoHistory color='blue' size={20} /></span>
                                    </div>
                                ,
                                issue:
                                    <div className='flex flex-row gap-2'>
                                        <span className='cursor-pointer self-center items-center justify-center' onClick={() => openAllotMedicineModal(item)} ><MdDewPoint size={20} /></span>
                                        <span className='cursor-pointer self-center items-center justify-center' onClick={() => navigate(isMedical ? `/medical/medicines/issue/history` : `/medicine/issue/history`, { state: { item } })} ><MdManageHistory color='blue' size={20} /></span>
                                    </div>
                                ,
                            }
                        )
                        )}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            tableData.count !== 0 ?
                <div className="xl:pl-5 pl-0">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={Math.ceil(tableData?.count / pageSize)}
                        pageSize={pageSize}
                        totalEntries={tableData?.count}
                        onPageChange={handlePageChange}
                        data={tableData}
                        setTableData={setTableData}
                    />
                </div> : <></>
        }
        <OpenMedicineQuantityAlert providedValues={openingValues} contentLabel={"Update Alert"} isOpen={addModalIsOpen} onRequestClose={closeModal} values={openingValues} onSave={onUpdateMedicine} />
        <AllotOpenMedicineAlert providedValues={openingValues} contentLabel={"Update Alert"} isOpen={allotModalIsOpen} onRequestClose={closeAllotModal} values={openingValues} onSave={onUpdateMedicine} />
    </>);
}

export default Medicines;